import { useSyncExternalStore } from "react";
import { recorder } from "./recorder.ts";
import { uploader } from "./uploader.ts";

export const useRecorder = () => useSyncExternalStore(recorder.subscribe, recorder.getState);
export const useUploads = () => useSyncExternalStore(uploader.subscribe, uploader.getState);
